import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import FileUploaderButton from '../../../Core/Controls/GenericFileUploader';
import { getJobRequireScheduledDocuments } from '../../../Core/Services/InternalUser/ControllerService/jobDetailsService';

const RecievedRequiredDocument = (props) => {
    const [jobdocument, setJobDocument] = useState({
        list: [],
        refresherFlag: ''
    });
    const GetDocs = async () => {
        if (props?.scheduleID) {
            let res = await getJobRequireScheduledDocuments(props?.scheduleID);
            setJobDocument((jobdocument) => ({ ...jobdocument, list: res.data.list }));
        }
    };
    useEffect(async () => {
        if (props?.scheduleID) {
            GetDocs();
        }
    }, [props?.scheduleID, jobdocument.refresherFlag]);

    const dataReload = () => {
        setJobDocument((jobdocument) => ({ ...jobdocument, refresherFlag: new Date() }));
        GetDocs();
    };

    return (
        <Grid
            container
            alignItems="center"
            style={{
                height: '95%',
                backgroundColor: '#f5f9f9',
                padding: '6px 16px'
            }}
        >
            {jobdocument.list.map((m) => {
                return (
                    <Grid item>
                        <div style={{ paddingTop: '5px' }}>
                            {/* {m.docName} */}
                            <span style={{ position: 'relative', top: '-7px', left: '7px', marginRight: '15px' }}>
                                <FileUploaderButton
                                    recordId={m.scheduleDocID}
                                    fileUploaderConfigName="ScheduleDocumentsRequired"
                                    fileCount={m.fileCount}
                                    gridRelaod={dataReload}
                                    docIDPassed={true}
                                    disabled={m.received == true}
                                    isDash={true}
                                    docName={m.docName}
                                />
                            </span>
                        </div>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default RecievedRequiredDocument;
